var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.89209H513V342.892H0V0.89209Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513 0.89209V171.892H0V0.89209H513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.8 289.892C250.859 289.892 303.6 237.151 303.6 172.092C303.6 107.033 250.859 54.292 185.8 54.292C120.741 54.292 68 107.033 68 172.092C68 237.151 120.741 289.892 185.8 289.892Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 171.892C68 106.792 120.8 54.0923 185.8 54.0923C250.9 54.0923 303.6 106.892 303.6 171.892",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.89209)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGl);
export default __webpack_public_path__ + "static/media/GL.7ede338f9239ae68243fb975e4be16de.svg";
export { ForwardRef as ReactComponent };